// Mobile utility functions for better mobile experience

// Check if device is mobile
export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           window.innerWidth <= 768;
};

// Check if device is iOS
export const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

// Check if device is Android
export const isAndroid = () => {
    return /Android/i.test(navigator.userAgent);
};

// Get viewport height accounting for mobile browsers
export const getViewportHeight = () => {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};

// Set viewport height CSS variable for mobile browsers
export const setViewportHeight = () => {
    const vh = getViewportHeight() * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Initialize mobile viewport handling
export const initMobileViewport = () => {
    if (isMobile()) {
        setViewportHeight();
        
        // Update on resize
        window.addEventListener('resize', setViewportHeight);
        window.addEventListener('orientationchange', () => {
            setTimeout(setViewportHeight, 100);
        });
    }
};

// Prevent zoom on input focus for iOS
export const preventZoomOnFocus = () => {
    if (isIOS()) {
        const inputs = document.querySelectorAll('input[type="text"], input[type="email"], input[type="password"]');
        inputs.forEach(input => {
            input.addEventListener('focus', () => {
                const viewport = document.querySelector('meta[name="viewport"]');
                if (viewport) {
                    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
                }
            });
            
            input.addEventListener('blur', () => {
                const viewport = document.querySelector('meta[name="viewport"]');
                if (viewport) {
                    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
                }
            });
        });
    }
};

// Add mobile-specific classes to body
export const addMobileClasses = () => {
    if (isMobile()) {
        document.body.classList.add('mobile-device');
    }
    if (isIOS()) {
        document.body.classList.add('ios-device');
    }
    if (isAndroid()) {
        document.body.classList.add('android-device');
    }
};

// Initialize all mobile utilities
export const initMobileUtils = () => {
    initMobileViewport();
    preventZoomOnFocus();
    addMobileClasses();
};
